import React, { Fragment } from 'react'
import { css } from '@emotion/css'
import { SizedTooltipList } from '../../application-tooltip/tooltip-content-pieces'
import { FormattedMessage } from 'react-intl'
import {
  ServerEnvironment,
  environmentI18nConfig
} from '../../servers-grid/shared'
import { TooltipLabel } from '../../../design-system'
import { TooltipLabelText } from '../../application-tooltip/tooltip-content-pieces/tooltip-label-text'
import { theme } from '../../../styled'

export function AttackEventServerTooltipContent({
  environment
}: {
  readonly environment: ServerEnvironment
}) {
  return (
    <Fragment>
      <div
        className={css`
          padding: 5px;
        `}
      >
        <FormattedMessage
          id="title_server"
          children={(message) => (
            <span
              className={css`
                font-weight: ${theme.fontWeights.secondary.boldest};
                padding-bottom: 1px;
              `}
            >
              {message}
            </span>
          )}
        />
        <SizedTooltipList>
          <li>
            <FormattedMessage id="title_environment_server">
              {(label) => {
                return (
                  <TooltipLabel
                    label={label as any}
                    renderValue={() => (
                      <FormattedMessage
                        id={environmentI18nConfig[environment]}
                        children={(message) => (
                          <TooltipLabelText>{message}</TooltipLabelText>
                        )}
                      />
                    )}
                  />
                )
              }}
            </FormattedMessage>
          </li>
        </SizedTooltipList>
      </div>
    </Fragment>
  )
}
